import { connect } from 'react-redux';
import { StoreState } from '../../../../reducers';

import Content from '../../../../components/Editor/Page/Content';

const mapStateToProps = (state: StoreState) => {
	const {
		editor: {
			slider: { page },
			pages,
			resources: { css, scripts },
		},
	} = state;

	return {
		html: pages[page] ? pages[page].html : '',
		css,
		scripts,
	};
};

export default connect(mapStateToProps)(Content);



// WEBPACK FOOTER //
// ./node_modules/tslint-loader!./src/containers/Editor/Page/Content/index.tsx